export const EVENT_DISCOVERY_PATH = '/event-discovery';
export const PROJECT_LIST_PATH = '/event-discovery/projects';
export const NEW_PROJECT_PATH = '/event-discovery/new';
export const HISTORY_PATH = '/event-discovery/history';
export const UPCOMING_PATH = '/event-discovery/upcoming';
export const SPEAKERS_PATH = '/event-discovery/speakers';
export const LINK_PROJECT_PATH = `${NEW_PROJECT_PATH}?source=links`;

export function rerunPath(runId: number): string {
  return `${NEW_PROJECT_PATH}?from=${runId}`;
}

export function projectPath(runId: number): string {
  return `/event-discovery/${runId}`;
}

export function importedSpeakersPath(projectId: string, runId: number): string {
  const query = new URLSearchParams({ project_id: projectId, return_url: projectPath(runId) });
  return `/people?${query.toString()}`;
}
